(function () {
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  function pageLang() {
    return document.documentElement.lang || 'en';
  }

  function formatDate(date) {
    try {
      return new Intl.DateTimeFormat(pageLang(), { day: 'numeric', month: 'long' }).format(date);
    } catch (error) {
      return MONTHS[date.getMonth()] + ' ' + ordinal(date.getDate());
    }
  }

  function ordinal(day) {
    if (day >= 11 && day <= 13) return day + 'th';
    switch (day % 10) {
      case 1:
        return day + 'st';
      case 2:
        return day + 'nd';
      case 3:
        return day + 'rd';
      default:
        return day + 'th';
    }
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Private line item property that ties a free gift to the bundle that unlocked it (see custom-gift-guard.js)
  var GIFT_PROPERTY = '_gift_for';

  // Unlockable gifts under the bundles (snippets/custom-offer-gifts.liquid)
  function initGifts(form, bundles) {
    var box = form.querySelector('[data-gifts]');
    var gifts = box ? Array.prototype.slice.call(box.querySelectorAll('[data-gift]')) : [];
    var status = box ? box.querySelector('[data-gifts-status]') : null;

    function position(input) {
      for (var i = 0; i < bundles.length; i++) {
        if (bundles[i].querySelector('input[name="id"]') === input) return i + 1;
      }
      return 0;
    }

    function unlockOf(gift) {
      return parseInt(gift.dataset.unlock, 10) || 1;
    }

    function setLocked(gift, locked) {
      gift.classList.toggle('is-locked', locked);
      if (locked) {
        gift.setAttribute('role', 'button');
        gift.setAttribute('tabindex', '0');
        gift.setAttribute('aria-label', gift.dataset.unlockLabel);
      } else {
        gift.removeAttribute('role');
        gift.removeAttribute('tabindex');
        gift.removeAttribute('aria-label');
      }
    }

    function describe(titles) {
      if (!titles.length) return 'Este paquete no incluye regalos.';
      var list = titles.length > 1 ? titles.slice(0, -1).join(', ') + ' y ' + titles[titles.length - 1] : titles[0];
      return (titles.length > 1 ? 'Regalos incluidos: ' : 'Regalo incluido: ') + list + '.';
    }

    function update(announce) {
      if (!gifts.length) return;
      var current = position(form.querySelector('input[name="id"]:checked'));
      var included = [];
      gifts.forEach(function (gift) {
        var unlocked = current >= unlockOf(gift);
        var wasLocked = gift.classList.contains('is-locked');
        setLocked(gift, !unlocked);
        if (!unlocked) return;
        included.push(gift.dataset.title);
        if (announce && wasLocked) {
          gift.classList.remove('is-unlocked-now');
          void gift.offsetWidth;
          gift.classList.add('is-unlocked-now');
        }
      });
      if (announce && status) status.textContent = describe(included);
    }

    // A locked gift selects the bundle that unlocks it
    function choose(gift, moveFocus) {
      if (!gift.classList.contains('is-locked')) return;
      var bundle = bundles[unlockOf(gift) - 1];
      var input = bundle && bundle.querySelector('input[name="id"]');
      if (!input || input.disabled) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (moveFocus) input.focus({ preventScroll: true });
    }

    gifts.forEach(function (gift) {
      gift.addEventListener('click', function () {
        choose(gift, false);
      });
      gift.addEventListener('keydown', function (event) {
        if ((event.key !== 'Enter' && event.key !== ' ') || !gift.classList.contains('is-locked')) return;
        event.preventDefault();
        choose(gift, true);
      });
      gift.addEventListener('animationend', function () {
        gift.classList.remove('is-unlocked-now');
      });
    });

    // Cart lines for the gifts that the bundle behind `input` unlocks
    function items(input) {
      var current = position(input);
      return gifts
        .filter(function (gift) {
          return current >= unlockOf(gift);
        })
        .map(function (gift) {
          var properties = {};
          properties[GIFT_PROPERTY] = String(input.value);
          return { id: parseInt(gift.dataset.variantId, 10), quantity: 1, properties: properties };
        });
    }

    return { update: update, items: items };
  }

  function initGallery(root) {
    var main = root.querySelector('[data-main]');
    var thumbsTrack = root.querySelector('[data-thumbs]');
    if (!main) return;
    var slides = main.children;
    var thumbs = thumbsTrack ? thumbsTrack.querySelectorAll('[data-index]') : [];
    var current = 0;

    function slideWidth() {
      if (slides.length < 2) return main.clientWidth;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    function markThumb(index) {
      thumbs.forEach(function (thumb, i) {
        var active = i === index;
        thumb.classList.toggle('is-active', active);
        if (active) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      if (thumbsTrack && thumbs[index]) {
        thumbsTrack.scrollTo({ left: thumbs[index].offsetLeft - thumbs[0].offsetLeft });
      }
    }

    function goTo(index) {
      var total = slides.length;
      current = ((index % total) + total) % total;
      main.scrollTo({ left: current * slideWidth() });
      markThumb(current);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.dataset.index, 10));
      });
    });

    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    var settle = null;
    main.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(settle);
        settle = window.setTimeout(function () {
          var index = Math.round(main.scrollLeft / slideWidth());
          if (index !== current) {
            current = Math.max(0, Math.min(slides.length - 1, index));
            markThumb(current);
          }
        }, 120);
      },
      { passive: true }
    );

    main.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(current + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(current - 1);
      }
    });
  }

  function initBuyBox(root) {
    var form = root.querySelector('form.custom-offer__form');
    if (!form) return;
    var bundles = form.querySelectorAll('.custom-offer__bundle');
    var button = form.querySelector('[data-add-button]');
    var buttonLabel = form.querySelector('[data-button-label]');
    var buttonPrice = form.querySelector('[data-button-price]');
    var buttonCompare = form.querySelector('[data-button-compare]');
    var buttonCompareValue = form.querySelector('[data-button-compare-value]');
    var errorBox = form.querySelector('[data-error]');
    var gifts = initGifts(form, bundles);
    var busy = false;

    function update(announce) {
      var checked = form.querySelector('input[name="id"]:checked');
      bundles.forEach(function (bundle) {
        var input = bundle.querySelector('input[name="id"]');
        var selected = input === checked;
        bundle.classList.toggle('is-selected', selected);
        if (selected) {
          buttonPrice.textContent = bundle.dataset.price;
          if (bundle.dataset.compare) {
            buttonCompareValue.textContent = bundle.dataset.compare;
            buttonCompare.hidden = false;
          } else {
            buttonCompareValue.textContent = '';
            buttonCompare.hidden = true;
          }
          var available = bundle.dataset.available === 'true';
          button.disabled = !available;
          buttonLabel.textContent = available ? button.dataset.label : button.dataset.soldOut;
        }
      });
      gifts.update(announce);
      if (errorBox) errorBox.hidden = true;
    }

    form.addEventListener('change', function (event) {
      if (event.target.name === 'id') update(true);
    });

    function reset() {
      busy = false;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-disabled');
      update();
    }

    function showError(message) {
      reset();
      if (!errorBox) return;
      errorBox.textContent = message || errorBox.dataset.message || 'Algo salió mal. Vuelve a intentarlo.';
      errorBox.hidden = false;
    }

    function post(url, body) {
      return fetch(rootUrl() + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
      }).then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            if (!response.ok) {
              var error = new Error('Cart request failed');
              error.status = response.status;
              error.userMessage = data && typeof data.description === 'string' ? data.description : '';
              throw error;
            }
            return data;
          });
      });
    }

    function getCart() {
      return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      });
    }

    function ownersOf(line) {
      var value = line.properties && line.properties[GIFT_PROPERTY];
      return value ? String(value).split(',') : [];
    }

    function bundleQuantity(cart, variantId) {
      return (cart.items || []).reduce(function (total, line) {
        return line.variant_id === variantId && !ownersOf(line).length ? total + line.quantity : total;
      }, 0);
    }

    // One of each gift per order: a gift already in the cart is not added again, it also gets tied to this bundle,
    // so it stays as long as any bundle that unlocks it is in the cart (custom-gift-guard.js)
    function planGifts(items, cart, bundleId) {
      var plan = { add: [], retag: [] };
      items.forEach(function (gift) {
        var line = (cart.items || []).filter(function (cartLine) {
          return cartLine.variant_id === gift.id && ownersOf(cartLine).length > 0;
        })[0];
        if (!line) {
          plan.add.push(gift);
          return;
        }
        var owners = ownersOf(line);
        if (owners.indexOf(bundleId) !== -1 && line.quantity === 1) return;
        if (owners.indexOf(bundleId) === -1) owners.push(bundleId);
        var properties = {};
        properties[GIFT_PROPERTY] = owners.join(',');
        plan.retag.push({ id: line.key, quantity: 1, properties: properties });
      });
      return plan;
    }

    function inSequence(requests) {
      return requests.reduce(function (previous, request) {
        return previous.then(function () {
          return post(request.url, request.body).catch(function () {});
        });
      }, Promise.resolve());
    }

    // When the cart keeps its lines, the bundle and the gifts it still lacks go in one request (gifts first, so the
    // cart lists the bundle on top). If Shopify refuses a line, the bundle goes in alone and then each gift it accepts.
    // A gift never blocks the purchase. If the cart can't be read first, nothing has changed yet, so the error shows.
    function addToCart(item, giftItems) {
      var bundleId = String(item.items[0].id);
      var plan = { add: [], retag: [] };
      var before = 0;
      var ready = giftItems.length
        ? getCart().then(function (cart) {
            plan = planGifts(giftItems, cart, bundleId);
            before = bundleQuantity(cart, item.items[0].id);
          })
        : Promise.resolve();
      return ready
        .then(function () {
          if (!plan.add.length) return post('cart/add.js', item);
          return post('cart/add.js', { items: plan.add.slice().reverse().concat(item.items) }).catch(function (error) {
            if (error.status === 429 || !(error.status >= 400 && error.status < 500)) throw error;
            return getCart()
              .then(function (cart) {
                // Plan again from the cart as it is now, so a gift that did go in is tagged rather than added twice
                plan = planGifts(giftItems, cart, bundleId);
                if (bundleQuantity(cart, item.items[0].id) <= before) return post('cart/add.js', item);
              })
              .then(function () {
                return inSequence(
                  plan.add.map(function (gift) {
                    return { url: 'cart/add.js', body: { items: [gift] } };
                  })
                );
              });
          });
        })
        .then(function () {
          return inSequence(
            plan.retag.map(function (change) {
              return { url: 'cart/change.js', body: change };
            })
          );
        });
    }

    // Shows the cart drawer with the new lines, the way Dawn's product form does.
    // An empty update returns the whole cart plus the rendered sections (cart.js ignores ?sections=).
    // It rejects when the drawer can't be shown, and the submit then opens the cart page instead.
    function openCartDrawer(opener) {
      var cartDrawer = document.querySelector('cart-drawer');
      return post('cart/update.js', { sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }).then(
        function (cart) {
          var sections = cart.sections || {};
          if (!cartDrawer || typeof cartDrawer.renderContents !== 'function' || !sections['cart-drawer'] || !sections['cart-icon-bubble']) {
            throw new Error('Cart drawer unavailable');
          }
          var wasOpen = cartDrawer.classList.contains('active');
          // Closing the drawer gives focus back to whatever opened it
          if (!wasOpen && typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(opener);
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(cart);
          var done = null;
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              done = publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-product-offer', cartData: cart });
            }
          } catch (error) {}
          reset();
          // Dawn traps focus only as the drawer opens, so a drawer that was already open gets it again now,
          // and every drawer once Dawn's own subscribers have re-rendered the lines
          var refocus = function () {
            if (!cartDrawer.classList.contains('active') || typeof trapFocus !== 'function') return;
            var active = document.activeElement;
            var inner = cartDrawer.querySelector('.drawer__inner');
            trapFocus(cartDrawer, active && active !== cartDrawer && cartDrawer.contains(active) ? active : inner);
          };
          if (wasOpen) refocus();
          Promise.resolve(done).then(refocus, refocus);
        }
      );
    }

    // With an empty cart the bundle and its gifts go in one request, so they land together or not at all.
    // The cart lists the last line added first, so the gifts go in reverse order before the bundle.
    // If Shopify refuses one of the lines, the bundle goes in alone and then each gift that Shopify still accepts.
    // Network errors, 5xx and 429 show the error instead, and the next click starts again from an empty cart.
    function addToEmptyCart(item, giftItems) {
      return post('cart/clear.js').then(function () {
        if (!giftItems.length) return post('cart/add.js', item);
        return post('cart/add.js', { items: giftItems.slice().reverse().concat(item.items) }).catch(function (error) {
          if (error.status === 429 || !(error.status >= 400 && error.status < 500)) throw error;
          return post('cart/clear.js')
            .then(function () {
              return post('cart/add.js', item);
            })
            .then(function () {
              return giftItems.reduce(function (previous, gift) {
                return previous.then(function () {
                  return post('cart/add.js', { items: [gift] }).catch(function () {});
                });
              }, Promise.resolve());
            });
        });
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var checked = form.querySelector('input[name="id"]:checked');
      if (busy || !checked || button.disabled) return;
      busy = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-disabled', 'true');
      var behaviour = form.dataset.behaviour || 'drawer';
      var item = { items: [{ id: parseInt(checked.value, 10), quantity: 1 }] };
      var giftItems = gifts.items(checked);
      var opener = form.contains(document.activeElement) ? document.activeElement : button;
      var added = false;
      var chain = behaviour === 'checkout_clear' ? addToEmptyCart(item, giftItems) : addToCart(item, giftItems);
      chain
        .then(function () {
          added = true;
          if (behaviour === 'drawer') return openCartDrawer(opener);
          // A failing subscriber must not keep the buyer from checkout
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-product-offer' });
            }
          } catch (error) {}
          window.location.href = behaviour === 'cart' ? rootUrl() + 'cart' : rootUrl() + 'checkout';
        })
        .catch(function (error) {
          // The lines are already in the cart: the cart page shows them, where an error would invite a second add
          if (added) {
            window.location.href = rootUrl() + 'cart';
            return;
          }
          showError(error && error.userMessage);
        });
    });

    // Coming back from checkout can restore the page from the back/forward cache with the button still loading.
    // Only then, so a first load doesn't free the button while a request is on its way.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) reset();
    });
    update();
  }

  function initDeliveryDate(root) {
    root.querySelectorAll('[data-delivery-days]').forEach(function (line) {
      var target = line.querySelector('[data-delivery-date]');
      if (!target) return;
      var days = parseInt(line.dataset.deliveryDays, 10) || 0;
      var date = new Date();
      date.setDate(date.getDate() + days);
      target.textContent = ' ' + formatDate(date);
    });
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-sticky]');
    var area = root.querySelector('[data-offer-area]');
    var buy = root.querySelector('.custom-offer__buy');
    if (!bar || !area) return;
    var footer = document.querySelector('.custom-footer, footer.shopify-section');
    var frame = null;

    function check() {
      frame = null;
      var pastOffer = area.getBoundingClientRect().bottom <= 0;
      var beforeFooter = !footer || footer.getBoundingClientRect().top > window.innerHeight;
      var visible = pastOffer && beforeFooter;
      bar.classList.toggle('is-visible', visible);
      var padding = visible && bar.offsetHeight ? bar.offsetHeight + 'px' : '';
      if (document.documentElement.style.scrollPaddingBottom !== padding) {
        document.documentElement.style.scrollPaddingBottom = padding;
      }
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!frame) frame = window.requestAnimationFrame(check);
      },
      { passive: true }
    );
    window.addEventListener('resize', function () {
      if (!frame) frame = window.requestAnimationFrame(check);
    });

    bar.querySelector('[data-sticky-button]').addEventListener('click', function () {
      (buy || area).scrollIntoView({ block: 'start' });
      var radio =
        root.querySelector('input[name="id"]:checked:not([disabled])') || root.querySelector('input[name="id"]:not([disabled])');
      if (radio) radio.focus({ preventScroll: true });
    });

    check();
  }

  function init(root) {
    if (!root || root.dataset.customOfferReady) return;
    root.dataset.customOfferReady = 'true';
    initGallery(root);
    initBuyBox(root);
    initDeliveryDate(root);
    initSticky(root);
  }

  function initAll() {
    document.querySelectorAll('[data-custom-offer]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-custom-offer]'));
  });
})();